import { clamp } from 'ramda';
/**
 * Хук выполняет расчет длины закрашенной части (fill) прогрессбара
 * */
export var useFillWidth = function useFillWidth(params) {
  var currentStepCount = params.currentStepCount,
    maxStepsCount = params.maxStepsCount;
  try {
    if (!Number.isInteger(maxStepsCount) || maxStepsCount <= 0) {
      throw new Error('Входные данные некорректны');
    }
    var percent = Math.floor(clamp(0, 1, currentStepCount / maxStepsCount) * 100);
    return "".concat(percent, "%");
  } catch (e) {
    return 0;
  }
};